import { AxiosRequestConfig } from 'axios';
import { HttpResource } from './http-resource';

type RequestConfig = Pick<AxiosRequestConfig, 'onUploadProgress' | 'signal' | 'cancelToken' | 'validateStatus'>;
type RequestUrlModifier = (url: string) => string;

const defaultUrlModifier: RequestUrlModifier = (url) => url;

export class Resource {
  constructor(
    private readonly _url: string,
    private readonly _resource: HttpResource,
  ) {}

  get resource(): HttpResource {
    return this._resource;
  }

  get url() {
    return this._url;
  }

  public child(url: string): Resource {
    return new Resource(`${this.url}/${url}`, this.resource);
  }

  public absolute(url: string): Resource {
    return new Resource(url, this._resource);
  }

  public get<T>(params?: AxiosRequestConfig['params'], urlModifier: RequestUrlModifier = defaultUrlModifier) {
    return this.resource.client.get<T>(urlModifier(this.url), { params }).then((r) => r.data);
  }

  public post<T>(data?: any, config?: RequestConfig) {
    return this.resource.client.post<T>(this.url, data, config).then((r) => r.data);
  }

  public put<T>(data?: any, config?: RequestConfig, urlModifier: RequestUrlModifier = defaultUrlModifier) {
    return this.resource.client.put<T>(urlModifier(this.url), data, config).then((r) => r.data);
  }

  public patch(data?: any, config?: RequestConfig, urlModifier: RequestUrlModifier = defaultUrlModifier) {
    return this.resource.client.patch(urlModifier(this.url), data, config).then((r) => r.data);
  }

  public delete<T>(urlModifier: RequestUrlModifier = defaultUrlModifier) {
    return this.resource.client.delete<T>(urlModifier(this.url)).then((r) => r.data);
  }
}
